import React, { useState } from "react";
import ContentContainer from "./contentContainer";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField, Typography } from "@mui/material";
import PageTitle from "./pageTitle";
import { useModelState, usePhoneMode } from '../../hooks';
import { parameterHelper, apiHostUrl } from "../../helpers";
import Spinner from "../spinner/Spinner";

const defaultState = { accountNumber: '', email: '', feedbackMessage: '', name: '' };
const emailRegEx = /^(?:[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+\.)*[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+@(?:(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!\.)){0,61}[a-zA-Z0-9]?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!$)){0,61}[a-zA-Z0-9]?)|(?:\[(?:(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\.){3}(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\]))$/;
const defaultParameters = { AccountNumber: '', FaultDetailId: null, UserName: null, Feature: null };

export default function FaultFeedback() {
    const { isMobile } = usePhoneMode();
    const [saving, setSaving] = useState(false);
    const [completed, setCompleted] = useState(false);
    const [error, setError] = useState(null);
    const { AccountNumber: prefilledAccountNumber, FaultDetailId: faultDetailId, UserName: userName, Feature: feature } = parameterHelper.getUrlParameters(defaultParameters);
    const [model, handleValueChanged, setModelState] = useModelState({ ...defaultState, accountNumber: prefilledAccountNumber, faultDetailId, userName, feature, email: userName });

    const { accountNumber, name, email, feedbackMessage } = model;

    let isEmailValid = false;
    if (!!email) {
        isEmailValid = email.match(emailRegEx);
    }

    const isValid = (!email || isEmailValid) && !!feedbackMessage && !saving;

    const handleSubmitClick = () => {
        setSaving(true);

        fetch(`${apiHostUrl}/api/v1/g3/feedback/fault`,
            {
                method: 'POST',
                body: JSON.stringify(model),
                headers: { 'Content-Type': 'application/json' }
            })
            .then((response) => {
                if (!response.ok) {
                    console.log(response);
                    setError('Error submitting contact');
                } else {
                    setModelState(defaultState);
                    setCompleted(true);
                    setTimeout(() => {
                        window.location.replace('/')
                    }, 3000);
                }
            }, (error) => {
                setError('Error submitting contact');
            }).finally(() => {
                setTimeout(() => {
                    setSaving(false);
                }, 250);
            });
    }

    return (
        <ContentContainer>
            <PageTitle title='Fault Feedback' />

            <Dialog
                open={!!error}
                onClick={() => setError(null)}
            >
                <DialogTitle>Error</DialogTitle>
                <DialogContent>{error}</DialogContent>
                <DialogActions>
                    <Button onClick={() => setError(null)}>Ok</Button>
                </DialogActions>
            </Dialog>

            <Box component="main" sx={{ p: !isMobile ? 3 : 1, width: '100%' }}>
                {saving ? (
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Spinner />
                        </Grid>
                    </Grid>
                ) : null}
                {!saving && completed ? (
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Typography variant="h6">Thank you for your feedback!</Typography>
                        </Grid>
                    </Grid>
                ): null}
                {!saving && !completed ? (
                    <Grid container padding={!isMobile ? 2 : 1}>
                        <Grid item md={6} p={1}>
                            <TextField
                                label="Name"
                                value={name || ''}
                                fullWidth
                                onChange={(event) => handleValueChanged('name', event.target.value)}
                            />
                        </Grid>
                        <Grid item md={6} p={1}>
                            <TextField
                                label="Email"
                                error={!!email && !isEmailValid}
                                helperText={!!email && !isEmailValid ? 'Invalid email address' : ''}
                                value={email || ''}
                                fullWidth
                                onChange={(event) => handleValueChanged('email', event.target.value)}
                            />
                        </Grid>
                        {!userName ? (
                            <Grid item md={6} p={1}>
                                <TextField
                                    label="Account Number"
                                    value={accountNumber || ''}
                                    fullWidth
                                    onChange={(event) => handleValueChanged('accountNumber', event.target.value)}
                                />
                            </Grid>
                        ) : null}
                        <Grid item md={12} p={1}>
                            <TextField
                                label="Feedback"
                                value={feedbackMessage || ''}
                                fullWidth
                                onChange={(event) => handleValueChanged('feedbackMessage', event.target.value)}
                                multiline
                                rows={6}
                            />
                        </Grid>
                        <Grid item md={12} p={1}>
                            <Button
                                disabled={!isValid}
                                onClick={handleSubmitClick}
                            >
                                Submit
                            </Button>
                        </Grid>
                    </Grid>
                ) : null}
            </Box>
        </ContentContainer>
    );
}